import styled from "styled-components";
import { textSize, text_size } from "@/app/utils/MixinSize";
import { Grid } from "@mui/material";
import { useLanguage } from "@/app/utils/LanguageContext";
import React, { useEffect, useState, useRef } from 'react';
import { useMyContext } from '@/app/utils/MyContext';
import "@/app/style/raceSelector2.scss"; 
import { RaceNo } from "@/app/utils/class/common/base";
//import { Swiper, SwiperSlide, useSwiper,  } from 'swiper/react';
//import SwiperCore from 'swiper/modules';
//import { Pagination, Navigation, Autoplay  } from 'swiper/modules';
//import 'swiper/css';
//import 'swiper/css/navigation';
//import 'swiper/css/pagination';

export type RaceSelectorData = {
    [venueCode: string]: { races: number[] };
}

type RaceSelectorProps = {
    type: string;
    //selectedRaceNo: number;
    //selectedVenueCode: string;
    handleSelectRace: (raceNo: RaceNo) => void;
    handleSelectMeeting: (index: number) => void
    //data?: any;
    enableAllBtn?: boolean;

    tabIdx: number;
    meetings: any;
    races: any;
    qidsRaces: any;
} 
 
export default function RaceSelector2(props: RaceSelectorProps) {
    const { handleSelectRace, handleSelectMeeting, type: displayType, tabIdx, meetings, races, qidsRaces} = props;
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const [isMobile, setIsMobile] = useState(props.type == "mobile");

    const refMtg = useRef<HTMLDivElement | null>(null);
    const refRace = useRef<HTMLDivElement | null>(null);

    //const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();
    //const [curSelectVenueCode, setCurSelectVenueCode] = useState(selectedVenueCode);
    const isResultPage = window.location.pathname.split('/').includes("results");
    useEffect(() => {
        const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (!isTouch && props.type == "mobile") setIsMobile(false);
    },[props.type])
 
    console.log("RaceSelector2", meetings, races) 
    useEffect(() => {
        // if(tabIdx > 0){
        //     console.log('RaceSelector2 UpComingRaceCards---', myContextState.selectedMeetingVenueCode, myContextState?.selectedRaceNo?.valueOf?.())
        //     const tarRaceId = `${myContextState.selectedMeeting?.id}${myContextState.selectedMeetingVenueCode}-${myContextState?.selectedRaceNo}`
        //     //setcurrace(tarRaceId)
    
        //     const mtgIndex = meetings?.findLastIndex((i:any, idx: number) => idx == tabIdx);
            
        //     console.log('RaceSelector2 tarRaceIndex---', mtgIndex, meetings, swiperInstance, tabIdx)
        //     if (tabIdx > -1) {
        //         swiperInstance?.slideTo(tabIdx, 300)
        //     }
        // }  
        const curMtgCla =  document.getElementsByClassName("curMtg")?.[0] as HTMLElement;
        const curRaceCla =  document.getElementsByClassName("curRace")?.[0] as HTMLElement; 
        console.log('RaceSelector2 curMtg---', curMtgCla)
        //const mtgSlide = document.getElementById("MtgSlide"); 
        refMtg?.current?.scrollTo(
            {left: curMtgCla?.offsetLeft ?? 0, 
            behavior: "smooth"});

        refRace?.current?.scrollTo(
            {left: ((curRaceCla?.offsetLeft ?? 0) - (curRaceCla?.parentElement?.offsetLeft ?? 0)), 
             behavior: "smooth"});
    
    }, [meetings, tabIdx])
  
    return (
        <Grid container className={`raceSelectorContainer1${displayType === "pc" ? " pc" : " mobile"}`} style={{padding: "0 0 0 12px"}}>
            {
                meetings && 
                <Grid item xs={12} sx={{display: 'flex', ...(displayType==="pc"&&{justifyContent: 'left'})}}>
                    <div ref={refMtg} id="MtgSlide" className={`stickyItem ${isMobile ? "mobile" : ""}`} >
                    {/* <Swiper 
                        onSwiper={setSwiperInstance}
                        //modules={[Pagination,Navigation,Autoplay]} 
                        spaceBetween={0}
                        className={"upComing_swiper"}
                        //pagination={true}
                        navigation={isMobile ? false : true}
                        autoplay={false}        
                        loop={false}
                        //initialSlide={meetings?.findLastIndex((i:any) => ["result","closed"].includes(i?.status?.toLowerCase())) + 1}
                        slidesPerGroup ={1}
                        resistanceRatio={0}
                        slidesPerView={'auto'}
                        > */}
                        {
                        meetings?.map((mtg: any, idx: number) => ( 
                            <div 
                                key={idx}
                                className={`headerItem ${idx == tabIdx && "selected curMtg"}`}
                                id="venue_code" 
                                onClick={() => handleSelectMeeting(idx)}>
                                    <p>{mtg?.meetingVenueCode || "--"}</p>
                            </div> 
                        )) 
                    }
                    {/* </Swiper> */}
                    </div> 
                    {(races && races?.length > 0) && <div className={`borderRight ${meetings?.length > 2 && displayType === "mobile" ? "sty " : ""}`}></div>}
                    
                    <div ref={refRace} className={`raceContent ${isMobile ? "mobile" : ""}`}> 
                    {
                        (isResultPage && displayType === "pc" && (races && races?.length > 0)) && <div className="raceItem" >
                            <div className={`headerItem ${myContextState.selectedRaceNo.valueOf()===-1 ? 'selected' : ''}`} onClick={() => handleSelectRace(new RaceNo(-1))}>
                                <p>{t('result_all')}</p>
                            </div>
                        </div>
                    }
                    {
                        races && races?.map((ra: any, i: number) => { 
                            const qRa = qidsRaces?.find((x: any) => x?.no == new RaceNo(ra?.displayName)?.valueOf());

                            return( <div key={i} className={ `raceItem ${myContextState.selectedRaceNo.isEqual(ra?.displayName) && "curRace"} ${qRa?.raceTrack?.description_en == "Turf" ? "turf" : (qRa?.raceTrack?.description_en ? "track" : "")}`}>
                                <div
                                    className={`headerItem ${myContextState.selectedRaceNo.isEqual(ra?.displayName) && "selected"} `}
                                    
                                    id={`raceSelect_no_${myContextState.selectedRaceNo}_${ra?.displayName}`}  
                                    onClick={() => (handleSelectRace(new RaceNo(ra?.displayName)))}
                                    >
                                    <p>{new RaceNo(ra?.displayName)?.valueOf()}</p>
                                </div>
                            </div>
                            )
                        })
                    } 
                    </div> 
                </Grid> 
            }
        </Grid>
    )
}